<template>
  <div class="c-contactFormFile">
    <div class="o-fieldsgrid" @dragover.prevent @drop.prevent>
      <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
        <input
          type="text"
          id="fromName"
          class="w-full validate input"
          :class="{ valid: fromName }"
          name="fromName"
          required="required"
          v-model="fromName"
        />
        <label for="fromName"> {{ translations["Name of contact"] }}* </label>
      </div>

      <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
        <input
          type="text"
          id="contactCompany"
          class="w-full validate input"
          :class="{ valid: company }"
          name="message['company']"
          required="required"
          v-model="company"
        />
        <label for="contactCompany"> {{ translations["Company"] }}* </label>
      </div>

      <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
        <input
          type="text"
          id="contactEmail"
          class="w-full validate input"
          :class="{ valid: fromEmail }"
          name="fromEmail"
          required="required"
          v-model="fromEmail"
        />
        <label for="contactEmail"> {{ translations["E-mail"] }}* </label>
      </div>

      <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--half">
        <input
          type="text"
          id="contactphone"
          class="w-full validate input"
          :class="{ valid: phone }"
          name="phone"
          required="required"
          v-model="phone"
        />
        <label for="contactphone"> {{ translations["Phone"] }}* </label>
      </div>

      <div class="o-input o-fieldsgrid__field o-fieldsgrid__field--full">
        <textarea
          rows="10"
          cols="40"
          id="message"
          :class="{ valid: message }"
          name="message[comment]"
          v-model="message"
        ></textarea>
        <label for="message">
          {{ translations["Comment"] }}
        </label>
      </div>
      <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
      <!-- <input type="file" @change="uploadFile" ref="file" multiple/> -->

      <div
        class="c-contactFormFile__uploads"
        @click.self="addFiles()"
        @drop="dropFiles"
      >
        <input
          multiple
          type="file"
          id="file"
          ref="files"
          v-on:change="handleFileUpload($event)"
        />

        <div v-if="!files.length" class="c-contactFormFile__uploads-empty">
		<plus-icon />
        Click to upload relevant pictures, drawings or documents
        </div>
		<div class="c-contactFormFile__uploads-files__container">
          <div v-for="(file, key) in files" :key="file.index" class="file c-contactFormFile__uploads-files">
            {{ file.name }}
            <span class="remove-file" v-on:click="removeFile(key)"><plus-icon /></span>
          </div>
		</div>
      </div>
    </div>
    <div
      tabindex="-1"
      aria-hidden="true"
      style="position: fixed; left: -100%; top: -100%"
    >
      <label
        for="50d642e8-add6-4cd0-aa23-0341da07a60c"
        aria-hidden="true"
        tabindex="-1"
      ></label>
      <input
        type="text"
        name="form_company"
        value=""
        id="50d642e8-add6-4cd0-aa23-0341da07a60c"
        tabindex="-1"
        aria-hidden="true"
        v-model="form_company"
      />
    </div>

    <div class="c-contactFormFile__submit">
      <div class="o-btn o-btn--button" @click="submitForm()">
        <div class="button"><chevron-icon /></div>
        {{ translations["Submit"] }}
      </div>
    </div>

    <transition name="fade">
      <div class="c-contactFormFile__loader" v-if="isSubmitting">
        <slot name="loader" v-if="!success"></slot>
        <slot name="success" v-if="success"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import ChevronIcon from "-!vue-svg-loader!../../images/chevron-right.svg";
import PlusIcon from "-!vue-svg-loader!../../images/icon-plus.svg";

import axios from "axios";

export default {
  name: "ContactFormFile",
  components: {
    vueDropzone: vue2Dropzone,
    ChevronIcon,
	PlusIcon
  },
  props: {
    csrf: String,
    translations: Object,
  },

  data: () => ({
    fromName: null,
    fromEmail: null,
    company: null,
    phone: null,
    message: null,
    form_company: null,
    files: [],

    submitStatus: null,
    isSubmitting: false,
    success: false,
    error: false,

    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 150,
      maxFilesize: 0.5,
      headers: { "My-Awesome-Header": "header value" },
    },
  }),

  methods: {
    addFiles() {
      this.$refs.files.click();
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },

    dropFiles(event) {
      let uploadedFiles = event.dataTransfer.files;
      this.storeFiles(uploadedFiles);
    },

    handleFileUpload(event) {
      let uploadedFiles = event.target.files;
      this.storeFiles(uploadedFiles);
    },
    storeFiles(uploadedFiles) {
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
    },

    async submitForm() {
      if (this.form_company) {
        return;
      }

      const formData = new FormData();
      formData.append("fromName", this.company + ", " + this.fromName);
      formData.append("fromEmail", this.fromEmail);
      formData.append("message[phone]", this.phone ? this.phone : "");
      formData.append("message[comment]", this.message ? this.message : "");

      let uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        let file = this.files[i];
        formData.append("attachment[" + i + "]", file);
      }

      this.sendEmail(formData);
    },

    sendEmail(formData) {
      this.isSubmitting = true;
      formData.append("action", "contact-form/send");
      formData.append("CRAFT_CSRF_TOKEN", this.csrf);

      axios
        .post(document.location.href, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((result) => {
          console.log(result.success);
          if (result.data.success) {
            this.submitStatus = "success";
            this.error = false;
            this.success = true;
            // this.fromName = null;
            // this.fromEmail = null;
            // this.company = null;
            // this.phone = null;
            // this.message = null;
            // this.subject = null;
            this.success = true;
          }

          if (result.data.errors) {
            this.error = true;
            this.success = false;
            this.submitStatus = "error";
            this.isSubmitting = false;
          }
        })
        .catch((e) => {
          this.submitStatus = "error";
          this.error = true;
          console.log(e);
        })
        .then(() => {
          setTimeout(() => {
            this.isSubmitting = false;
            this.success = false;
          }, 1800);
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";
.c-contactFormFile {
  width: calc(100% - 60px);
  max-width: 1140px;

  .o-btn{
	  text-transform: uppercase;
  }

  &__loader {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
  }

  &__uploads {
	cursor: pointer;
    display: flex;
	flex-wrap: wrap;
    // justify-content: center;
    // align-items: center;
    width: 100%;
    margin-bottom: 26px;
    padding: 30px;
    border: 1px dashed #a7a7a7;
    background: rgba(#ffffff, 0.7);
    input {
      position: absolute;
      opacity: 0;
      left: -500px;
      visibility: hidden;
    }

	&-empty{
		width: 100%;
		pointer-events: none;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #2E2E2D;
		font-size: 18px;
		svg{
			fill: #EBEBEB;
			width: 60px;
			height: 60px;
			margin-bottom: 10px;
		}
	}
	&-files{
		&__container{
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			justify-content: center;
			pointer-events: none;
		}
		background-color: #EBEBEB;
		padding: 10px 20px;
		margin: 5px;
		align-items: center;
		display: flex;
		justify-content: center;
		pointer-events: all;

		.remove-file{
			height: 30px;
			width: 30px;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover{
				svg{
					transition: $t-hover;
					fill: $brand-orange;
				}
			}
		}

		svg{
			transition: $t-hover;
			transform: rotate(45deg);
			width: 20px;
			height: 20px;
			margin-left: 5px;
			margin-bottom: -1px;
		}
	}
  }

  &__submit {
    width: 100%;
    display: flex;
    align-items: flex-end;
    cursor: pointer;
    .o-btn {
      margin-left: auto;
      color: #172642;

      &:hover {
        color: #ffffff;
      }
    }
  }
}
</style>
